(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["personalization-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('personalization-fields')) {
    customElements.define(
      'personalization-fields',
      class PersonalizationFields extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');
          this.textInput = this.querySelector('[name="properties[Embroidery text]"]');
          this.confirmInput = this.querySelector('[name="properties[Personalization confirmed]"]');
          this.counter = this.querySelector('.personalized-product-fields__count');
          this.error = this.querySelector('.personalized-product-fields__error');

          if (!this.form || !this.textInput || !this.confirmInput || !this.error) return;

          this.validate = this.validate.bind(this);
          this.update = this.update.bind(this);
          this.form.addEventListener('submit', this.validate, true);
          this.textInput.addEventListener('input', this.update);
          this.confirmInput.addEventListener('change', this.update);
          this.update();
        }

        disconnectedCallback() {
          if (this.form) this.form.removeEventListener('submit', this.validate, true);
          if (this.textInput) this.textInput.removeEventListener('input', this.update);
          if (this.confirmInput) this.confirmInput.removeEventListener('change', this.update);
        }

        update() {
          const value = this.textInput.value;
          this.textInput.setCustomValidity(value.trim() ? '' : this.error.dataset.textError);
          if (this.counter) this.counter.textContent = `${value.length} / ${this.textInput.maxLength}`;
          if (this.textInput.validity.valid && this.confirmInput.checked) {
            this.error.hidden = true;
            this.error.textContent = '';
          }
        }

        validate(event) {
          this.update();
          if (this.textInput.validity.valid && this.confirmInput.checked) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          this.error.textContent = this.error.dataset.requiredError;
          this.error.hidden = false;

          const firstInvalid = this.textInput.validity.valid ? this.confirmInput : this.textInput;
          firstInvalid.focus();
          firstInvalid.reportValidity();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-sticky-cart')) {
    customElements.define(
      'product-sticky-cart',
      class ProductStickyCart extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.price = this.querySelector('.product-sticky-cart__price');
          this.button = this.querySelector('button');
          this.priceSource = document.getElementById(`price-${this.sectionId}`);

          if (!this.mainButton || !this.button) return;

          this.handleClick = () => this.mainButton.click();
          this.button.addEventListener('click', this.handleClick);
          this.sync = this.sync.bind(this);
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
          if (this.priceSource) this.observer.observe(this.priceSource, { childList: true, subtree: true });
          this.visibilityObserver = new IntersectionObserver(
            ([entry]) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            },
            { threshold: 0.01 }
          );
          this.visibilityObserver.observe(this.mainButton);
          this.hidden = false;
          this.sync();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.visibilityObserver) this.visibilityObserver.disconnect();
          if (this.button && this.handleClick) this.button.removeEventListener('click', this.handleClick);
        }

        sync() {
          this.button.disabled = this.mainButton.disabled;
          const mainLabel = this.mainButton.querySelector('span');
          if (mainLabel) this.button.textContent = mainLabel.textContent.trim();
          const currentPrice =
            this.priceSource?.querySelector('.price__sale .price-item--sale') ||
            this.priceSource?.querySelector('.price__regular .price-item--regular');
          if (currentPrice) this.price.textContent = currentPrice.textContent.trim();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
